interface Props {
    className?: string;
}

export function SpinnerIcon({ className }: Props) {
    return (
        <svg className={className} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16 0.69867C16 0.312805 16.313 -0.00159215 16.6985 0.0152518C18.6934 0.102418 20.6565 0.562366 22.4857 1.37345C24.528 2.27905 26.358 3.6023 27.8579 5.25802C29.3578 6.91373 30.4943 8.86521 31.1943 10.9868C31.8213 12.887 32.0856 14.8859 31.9758 16.8797C31.9546 17.2649 31.6109 17.5454 31.2269 17.5074C30.8429 17.4694 30.5642 17.1273 30.5838 16.7419C30.6753 14.9425 30.4332 13.1395 29.8674 11.4246C29.2285 9.48832 28.1912 7.70727 26.8223 6.19616C25.4534 4.68504 23.7832 3.47735 21.9193 2.65085C20.2685 1.91885 18.4981 1.50022 16.6984 1.41405C16.313 1.3956 16 1.08453 16 0.69867Z"
                fill="currentColor"
            />
        </svg>
    );
}
